import React, { useContext, useEffect, useRef, useState } from "react";
import { IMAGES } from "../../assets";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context";
import {
  getCategoryList,
  getEbookList,
  getFcmTokenUpdate,
  getProgressOfBook,
} from "../../api";
import { SHOW_TOAST, STORAGE_KEY, STRINGS } from "../../constants";
import BookListCard from "../../components/book/BookListCard";
import ProgressBar from "../../components/ProgressBar";
import { useNavigate } from "react-router-dom";
import { requestToken } from "../../firebase/accoount";
import { FILE_URL } from "../../constants/Constants";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";

const Home = () => {
  const { user, activeLanguage } = useContext(AuthContext);

  const { t } = useTranslation();

  const [selectedListItem, setSelectedListItem] = useState("All");

  const [isLoading, setIsLoading] = useState(false);
  const [newlyAddedBookList, setNewlyAddedBookList] = useState([]);
  const [otherBookList, setotherBookList] = useState([]);
  const [bookProgressItem, setBookProgressItem] = useState("");
  const [categoryItem, setCategoryItem] = useState([]);
  const [trendingBookList, setTrendingBookList] = useState([]);

  //FOR SHOWING DOWNLOAD BOOK
  const [arrayDownload, setArrayDownload] = useState([]);
  const navigate = useNavigate();
  const slider = useRef(null);

  useEffect(() => {
    Ebooklist();
  }, [selectedListItem]);

  useEffect(() => {
    getBookProgress();
  }, []);

  useEffect(() => {
    categoryListing();
  }, []);

  useEffect(() => {
    getDownloadedItem();
  }, []);

  async function getBookProgress() {
    const params = {
      userId: user?.userInfo?._id,
    };

    const result = await getProgressOfBook(params);

    if (result?.status) {
      const response = result?.data?.eBookProgress;
      setBookProgressItem(response);
    } else {
      console.error(result?.error);
    }
  }

  async function categoryListing() {
    const result = await getCategoryList();
    const res = result?.data?.data ?? [];
    const allItem = { categoryName: "All", marathiName: "सर्व" };
    const array = [allItem, ...res];
    setSelectedListItem(allItem);
    setCategoryItem(array);
  }

  async function getDownloadedItem() {
    const arrayStr = localStorage.getItem(STORAGE_KEY.DOWNLOADED_BOOK_ITEM);
    if (arrayStr) {
      let array = JSON.parse(arrayStr);
      setArrayDownload(array);
    }
  }

  async function Ebooklist() {
    let params;
    if (selectedListItem?.categoryName == "All") {
      params = {
        userId: user?.userInfo?._id,
      };
    } else {
      params = {
        type: selectedListItem?.categoryName,
        userId: user?.userInfo?._id,
      };
    }

    setIsLoading(true);
    const result = await getEbookList(params);
    setIsLoading(false);
    if (result?.status) {
      // setCategoryWiseBookList(result?.data?.data?.categoryWiseBookList);
      setNewlyAddedBookList(result?.data?.data?.newlyAddedBookList);
      setotherBookList(result?.data?.data?.otherBookList);
      setTrendingBookList(result?.data?.data?.treandingBookList);
    } else {
      SHOW_TOAST(result?.error);
      localStorage.clear();
      navigate("/");
    }
  }

  const getTokenData = async () => {
    const token = await requestToken();
    if (token) {
      try {
        await getFcmTokenUpdate({
          _id: user?.userInfo?._id,
          fcm_token: token,
        });
      } catch (err) {
        console.log(err, "update token error");
      }
    }
  };

  // Custom arrow components
  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        className="text-[#480D9B] ml-3 flex items-center justify-center p-1 border rounded-full"
        onClick={onClick}
      >
        <CaretRightOutlined className="" />
      </button>
    );
  };

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        className="text-[#480D9B] ml-3 flex items-center justify-center p-1 border rounded-full"
        onClick={onClick}
      >
        <CaretLeftOutlined className="" />
      </button>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    getTokenData();
  }, []);

  return (
    <div>
      <div className="progess card">
        {!bookProgressItem ||
        bookProgressItem?.bookImage === undefined ? null : (
          <div className="bg-[#FFE1CC5E] w-full rounded-xl px-4 py-2">
            <div
              role="button"
              onClick={() =>
                navigate(`/aboutbook/${bookProgressItem?._id}`, {
                  state: { item: bookProgressItem },
                })
              }
              className="flex items-center gap-4"
            >
              <div className="h-32 w-20 border-2 rounded-xl">
                {/* <Slider arrows={false} {...settings}>
                  {typeof bookProgressItem?.bookImage === "object" &&
                    bookProgressItem?.bookImage?.length > 1 &&
                    bookProgressItem?.bookImage?.map((ele) => (
                      <img
                        className="h-32 w-32 object-cover rounded-xl"
                        src={ele ?? IMAGES?.logo}
                        alt="book cover"
                      />
                    ))}
                </Slider> */}

                {typeof bookProgressItem?.bookImage === "object" &&
                  bookProgressItem?.bookImage?.length >= 1 && (
                    <img
                      className="h-full w-full object-cover rounded-xl"
                      src={
                        bookProgressItem?.bookImage[0]
                          ? `${FILE_URL}${bookProgressItem?.bookImage[0]}`
                          : IMAGES?.logo
                      }
                      // src={bookProgressItem?.bookImage[0] ?? IMAGES?.logo}
                      alt="book cover"
                    />
                  )}

                {typeof bookProgressItem?.bookImage === "string" && (
                  <img
                    className="h-full w-full object-cover rounded-xl"
                    src={bookProgressItem?.bookImage ?? IMAGES?.logo}
                    alt="book cover"
                  />
                )}
              </div>

              {/* <img
                className="h-32 w-auto rounded-xl"
                src={bookProgressItem?.bookImage ?? IMAGES?.richDadPoorIcon}
              /> */}
              <div className="w-full">
                <div className="flex items-baseline justify-between">
                  <div>
                    <h2 className="text-lg font-bold">
                      {bookProgressItem?.bookName ?? ""}
                    </h2>
                    <span className="text-base font-medium">
                      {bookProgressItem?.authorName ?? ""}
                    </span>
                  </div>
                  <div className="text-sm flex items-center justify-center gap-2">
                    <img className="h-4 " src={IMAGES.starIcon} />
                    {activeLanguage === "Marathi" ? (
                      <span>
                        {typeof bookProgressItem?.overallRating === "number"
                          ? new Intl.NumberFormat("mr", {
                              maximumSignificantDigits: 2,
                            }).format(
                              (bookProgressItem?.overallRating * 5) / 100
                            )
                          : 0}
                      </span>
                    ) : (
                      <span>
                        {typeof bookProgressItem?.overallRating === "number"
                          ? (
                              (bookProgressItem?.overallRating * 5) /
                              100
                            ).toFixed(1)
                          : 0}
                      </span>
                    )}
                  </div>
                </div>

                <ProgressBar
                  color="#FE6B01"
                  percentage={
                    bookProgressItem?.readingPercent > 100
                      ? 100
                      : bookProgressItem?.readingPercent ?? "0"
                  }
                  height="8px"
                />
                {/* <div className="w-full relative rounded-2xl p-1 mt-2 bg-[#FFFFFF]">
                  <div className="absolute top-0 left-0 w-1/2 rounded-2xl p-1 bg-[#FE6B01]"></div>
                </div> */}
                {activeLanguage === "Marathi" ? (
                  <span className="text-sm">
                    {`${
                      bookProgressItem?.readingPercent
                        ? new Intl.NumberFormat("mr", {
                            maximumSignificantDigits: 2,
                          }).format(
                            bookProgressItem?.readingPercent?.toFixed(2)
                          ) + " % "
                        : "0%"
                    } ${t(STRINGS.completed)}`}
                  </span>
                ) : (
                  <span className="text-sm">{`${
                    bookProgressItem?.readingPercent
                      ? bookProgressItem?.readingPercent?.toFixed(2) + "%"
                      : "0%"
                  } ${t(STRINGS.completed)}`}</span>
                )}
                {/* <span className="text-sm ">
                  {bookProgressItem?.readingPercent?.toFixed(2) > 100
                    ? 100
                    : bookProgressItem?.readingPercent?.toFixed(2) ?? "0"}
                  % {t(STRINGS?.completed)}
                </span> */}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* tabs */}
      {/* <div className="my-4 flex flex-wrap items-center gap-2 ">
        <Slider arrows={true} {...settings}>
          {categoryItem?.map((item) => {
            return (
              <button
                key={item?._id}
                onClick={() => setSelectedListItem(item)}
                className={`${
                  selectedListItem == item
                    ? "bg-[#480D9B] text-white"
                    : "text-[#8A8A8A]  bg-[#FFFFFF]"
                } tab-btn py-2 px-5  text-sm border border-[#0000001A] rounded-2xl`}
              >
                {localStorage.getItem("ACTIVE_LANGUAGE") === "Marathi"
                  ? item?.marathiName
                  : item?.categoryName}
              </button>
            );
          })}
        </Slider>
      </div> */}
      <div
        className={` ${
          categoryItem?.length > 0 ? "flex" : "block"
        } items-center justify-center w-full`}
      >
        <button
          className="text-[#480D9B] ml-3 flex items-center justify-center p-1 border rounded-full"
          onClick={() => slider?.current?.slickPrev()}
        >
          <CaretLeftOutlined className="" />
        </button>

        <div className="my-4 overflow-hidden relative w-full">
          <Slider
            arrows={true}
            ref={slider}
            className="flex items-center justify-center relative"
            {...settings}
          >
            {categoryItem?.map((item, index) => (
              <div key={index} className="p-2 ">
                {" "}
                {/* Added padding for spacing */}
                <button
                  onClick={() => setSelectedListItem(item)}
                  className={`${
                    selectedListItem === item
                      ? "bg-[#480D9B] text-white"
                      : "text-[#8A8A8A] bg-[#FFFFFF]"
                  } tab-btn py-2 px-5 text-sm border border-[#0000001A] rounded-2xl w-full`}
                >
                  {localStorage.getItem("ACTIVE_LANGUAGE") === "Marathi"
                    ? item?.marathiName
                    : item?.categoryName}
                </button>
              </div>
            ))}
          </Slider>
        </div>

        <button
          className="text-[#480D9B] ml-3 flex items-center justify-center p-1 border rounded-full"
          onClick={() => slider?.current?.slickNext()}
        >
          <CaretRightOutlined className="" />
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 lg:gap-4 md:gap-2 sm:gap-2 gap-2">
        {trendingBookList?.length > 0 && (
          <BookListCard
            title={t(STRINGS.trending_books)}
            data={trendingBookList}
            onClick={() =>
              navigate("/books/trendingbooks", {
                state: {
                  otheBookItem: trendingBookList,
                  title: t(STRINGS?.trending_books),
                },
              })
            }
            link={true}
          />
        )}

        {arrayDownload == "" ? null : (
          <BookListCard
            title={t(STRINGS?.trending_books)}
            data={arrayDownload}
            onClick={() =>
              navigate("/books/trendingbooks", {
                state: {
                  otheBookItem: arrayDownload,
                  title: t(STRINGS?.trending_books),
                },
              })
            }
            link={true}
          />
        )}

        {newlyAddedBookList?.length > 0 && (
          <BookListCard
            title={t(STRINGS?.newly_added_books)}
            data={newlyAddedBookList}
            onClick={() =>
              navigate("/books/newlyadded", {
                state: {
                  otheBookItem: newlyAddedBookList,
                  title: t(STRINGS?.newly_added_books),
                },
              })
            }
            link={true}
          />
        )}

        {!otherBookList ? null : (
          <BookListCard
            title={t(STRINGS.featured_books)}
            data={otherBookList}
            onClick={() =>
              navigate("/books/otherbooks", {
                state: {
                  otheBookItem: otherBookList,
                  title: t(STRINGS.featured_books),
                },
              })
            }
            link={true}
          />
        )}
      </div>
    </div>
  );
};

export default Home;
